"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventNames = exports.Cyclos = exports.Network = exports.MAIN_NET = exports.LOCAL_NET = exports.DEV_NET = exports.POSITION_CLOSED = exports.POSITION_CLOSURE_REQUESTED = exports.POSITION_ACTIVE = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const network_1 = require("./network");
Object.defineProperty(exports, "DEV_NET", { enumerable: true, get: function () { return network_1.DEV_NET; } });
Object.defineProperty(exports, "LOCAL_NET", { enumerable: true, get: function () { return network_1.LOCAL_NET; } });
Object.defineProperty(exports, "MAIN_NET", { enumerable: true, get: function () { return network_1.MAIN_NET; } });
Object.defineProperty(exports, "Network", { enumerable: true, get: function () { return network_1.Network; } });
const cyclos_json_1 = __importDefault(require("./idl/cyclos.json"));
const seeds_1 = require("./seeds");
const utils_1 = require("./utils");
const types_1 = require("./types");
Object.defineProperty(exports, "POSITION_ACTIVE", { enumerable: true, get: function () { return types_1.POSITION_ACTIVE; } });
Object.defineProperty(exports, "POSITION_CLOSURE_REQUESTED", { enumerable: true, get: function () { return types_1.POSITION_CLOSURE_REQUESTED; } });
Object.defineProperty(exports, "POSITION_CLOSED", { enumerable: true, get: function () { return types_1.POSITION_CLOSED; } });
Object.defineProperty(exports, "EventNames", { enumerable: true, get: function () { return types_1.EventNames; } });
class Cyclos {
    constructor(connection, network, wallet, programId, opts) {
        this.idl = cyclos_json_1.default;
        this.connection = connection;
        this.network = network;
        this.wallet = wallet;
        this.opts = opts;
        const provider = new anchor_1.Provider(connection, wallet, opts || anchor_1.Provider.defaultOptions());
        switch (network) {
            case network_1.Network.LOCAL:
                this.programId = programId;
                this.crankAuthority = network_1.LOCAL_NET.crankAuthority;
                break;
            case network_1.Network.DEV:
                this.programId = network_1.DEV_NET.cyclos;
                this.crankAuthority = network_1.DEV_NET.crankAuthority;
                break;
            case network_1.Network.MAIN:
                this.programId = network_1.MAIN_NET.cyclos;
                this.crankAuthority = network_1.MAIN_NET.crankAuthority;
                break;
            default:
                throw new Error('Not supported');
        }
        this.program = new anchor_1.Program(cyclos_json_1.default, this.programId, provider);
    }
    // Generate PDAs
    /**
     * Get a new NFT mint address for creating position
     * NFT mint addresses are namespaced by market and owner keys, then randomized
     * with a seed
     * @param market
     * @param owner
     * @param mintInitRandomSeed
     * @returns public key and nonce
     */
    getNftMintPda(market, owner, mintInitRandomSeed) {
        return web3_js_1.PublicKey.findProgramAddress([
            seeds_1.MINT_SEED,
            // Namespace by market key
            market.toBuffer(),
            owner.toBuffer(),
            (0, utils_1.numberToBigEndian)(mintInitRandomSeed)
        ], this.program.programId);
    }
    /**
     * Get position data account address
     * Each position NFT mint is associated with a data account
     * @param positionNftMint
     * @returns public key and nonce
     */
    getPositionDataPda(positionNftMint) {
        return web3_js_1.PublicKey.findProgramAddress([
            seeds_1.POSITION_ACCOUNT_SEED,
            positionNftMint.toBuffer(),
        ], this.program.programId);
    }
    /**
     * Get authority for the smart contract's token accounts and open_orders accounts
     * This is a singular account controlling all pools
     * @returns public key and nonce
     */
    getVaultAuthorityPda() {
        return web3_js_1.PublicKey.findProgramAddress([seeds_1.AUTHORITY_SEED], this.program.programId);
    }
    /**
     * Get open orders account PDA
     * Namespaced by market address
     * @param positionNftMint
     * @returns public key and nonce
     */
    getOpenOrdersPda(market) {
        return web3_js_1.PublicKey.findProgramAddress([
            seeds_1.OPEN_ORDERS_SEED,
            market.toBuffer(),
        ], this.program.programId);
    }
    /**
     * Typed RPC client to call smart contract functions
     * @returns RPC client
     */
    getRpcClient() {
        return this.program.rpc;
    }
    /**
     * Typed Accounts client to read smart contract accounts
     * @returns Account client
     */
    getAccountClient() {
        return this.program.account;
    }
}
exports.Cyclos = Cyclos;
